import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight, faCheck} from '@fortawesome/free-solid-svg-icons'
import logoImage from '../img/consultMidiaLogo.png';
import {useHistory} from "react-router-dom";
import React from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import FacebookPixel from "../capturePixel/Facebook";

export function FourthQuestion() {
    const history = useHistory();

    const MySwal = withReactContent(Swal);

    function handleQuestion() {
        const nameCompany = document.getElementById("nameCompany") as HTMLInputElement;

        if (validateName()) {
            sessionStorage.setItem('nameCompany', nameCompany.value);
            history.push('/fifth');
        } else {
            MySwal.fire({
                icon: 'warning',
                title: '',
                text: "Campo Obrigatório",
                position: 'top',
                showConfirmButton: false,
                timer: 1500,
            })
        }
    }

    function validateName() {
        let nameValidation = document.getElementById("nameCompany") as HTMLInputElement;

        return (nameValidation.value.length > 1)
    }


    function clickButton(event: React.KeyboardEvent<HTMLInputElement>) {
        const buttonSubmit = document.getElementById("buttonSubmit") as HTMLInputElement;
        if (event.key === "Enter") {
            buttonSubmit.click();
        }
    }

    return (
        <>
            <FacebookPixel nameTracking="Fourth"/>
            <div className="progress">
                <div className="progress-bar progress-bar-80" role="progressbar"/>
            </div>
            <div className="container">
                <div className=" d-block d-md-none">
                    <img className="img-fluid image" src={logoImage} alt="logo"/>
                </div>
                <section className="container-body">
                    <div className="row d-flex flex-column align-content-lg-start">
                        <div className="col-md-2 icon">
                            <span>4<FontAwesomeIcon icon={faArrowRight}/></span>
                        </div>
                        <div className="col-md-6 align-self-end mr-5">
                            <span className="span">Queremos conhecer melhor o seu negócio, nos diga, qual o nome da sua empresa ou organização em que trabalha.</span>


                            <div className="py-2 pr-4">
                                <input autoFocus className="input" onKeyDown={clickButton} id="nameCompany"
                                       type="text" placeholder="Responde aqui..."/>
                            </div>
                        </div>
                    </div>
                    <div className="row next">
                        <div className="col-sm-2">
                            <button id="buttonSubmit" onClick={handleQuestion}>Próximo<FontAwesomeIcon icon={faCheck}/>
                            </button>
                        </div>
                        <div className="col-sm-10 confirmation">
                            Pressione <strong>Enter ↵</strong>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}